<template>
<div>
  <div class="wistia_embed wistia_async_topo7272iv">
    &nbsp;
  </div>

  <div
    id="hsa_occasions"
    class="tbk-vid-embed"
  >
    <a
      id="saving_for_baby"
      class="embedded_video"
      href="#wistia_5t1xif6qhn?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="healthy_and_invincible"
      class="embedded_video"
      href="#wistia_putt609gng?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="affording_chronic_care"
      class="embedded_video"
      href="#wistia_cebcqf9uft?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('top', 35, this.showSelect)
    this.tbk.loadCrossTime('5t1', 190, this.showSelect)
    this.tbk.loadCrossTime('put', 170, this.showSelect)
    this.tbk.loadCrossTime('ceb', 167, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '5t1': this.tbk.autoPlay,
        put: this.tbk.autoPlay,
        ceb: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#hsa_occasions
  display: none
  a
    text-decoration: none
#saving_for_baby
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (42 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))
#healthy_and_invincible
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (239 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))
#affording_chronic_care
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (438 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))
</style>
